
// @ts-nocheck


export const localeCodes =  [
  "en",
  "zh",
  "ja",
  "zh-TW",
  "ko",
  "hi",
  "de",
  "ar",
  "fr",
  "id",
  "itb",
  "uk"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46ts_335fd0eb",
      load: () => import("#nuxt-i18n/335fd0eb" /* webpackChunkName: "locale_en_46ts_335fd0eb" */),
      cache: false
    }
  ],
  zh: [
    {
      key: "locale_zh_45CN_46ts_69a42ec6",
      load: () => import("#nuxt-i18n/69a42ec6" /* webpackChunkName: "locale_zh_45CN_46ts_69a42ec6" */),
      cache: false
    }
  ],
  ja: [
    {
      key: "locale_ja_46ts_8de6d14b",
      load: () => import("#nuxt-i18n/8de6d14b" /* webpackChunkName: "locale_ja_46ts_8de6d14b" */),
      cache: false
    }
  ],
  "zh-TW": [
    {
      key: "locale_zh_45TW_46ts_8f9add06",
      load: () => import("#nuxt-i18n/8f9add06" /* webpackChunkName: "locale_zh_45TW_46ts_8f9add06" */),
      cache: false
    }
  ],
  ko: [
    {
      key: "locale_ko_46ts_40754a7e",
      load: () => import("#nuxt-i18n/40754a7e" /* webpackChunkName: "locale_ko_46ts_40754a7e" */),
      cache: false
    }
  ],
  hi: [
    {
      key: "locale_hi_46ts_e26055cf",
      load: () => import("#nuxt-i18n/e26055cf" /* webpackChunkName: "locale_hi_46ts_e26055cf" */),
      cache: false
    }
  ],
  de: [
    {
      key: "locale_de_46ts_688a6625",
      load: () => import("#nuxt-i18n/688a6625" /* webpackChunkName: "locale_de_46ts_688a6625" */),
      cache: false
    }
  ],
  ar: [
    {
      key: "locale_ar_46ts_41c1458a",
      load: () => import("#nuxt-i18n/41c1458a" /* webpackChunkName: "locale_ar_46ts_41c1458a" */),
      cache: false
    }
  ],
  fr: [
    {
      key: "locale_fr_46ts_c48971cb",
      load: () => import("#nuxt-i18n/c48971cb" /* webpackChunkName: "locale_fr_46ts_c48971cb" */),
      cache: false
    }
  ],
  id: [
    {
      key: "locale_id_46ts_95f6763f",
      load: () => import("#nuxt-i18n/95f6763f" /* webpackChunkName: "locale_id_46ts_95f6763f" */),
      cache: false
    }
  ],
  itb: [
    {
      key: "locale_it_46ts_c7466c68",
      load: () => import("#nuxt-i18n/c7466c68" /* webpackChunkName: "locale_it_46ts_c7466c68" */),
      cache: false
    }
  ],
  uk: [
    {
      key: "locale_uk_46ts_c09c8e1b",
      load: () => import("#nuxt-i18n/c09c8e1b" /* webpackChunkName: "locale_uk_46ts_c09c8e1b" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      iso: "en-US",
      name: "English",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/en.ts"
      ]
    },
    {
      code: "zh",
      iso: "zh-CN",
      name: "简体中文",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/zh-CN.ts"
      ]
    },
    {
      code: "ja",
      iso: "ja-JP",
      name: "日文",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/ja.ts"
      ]
    },
    {
      code: "zh-TW",
      iso: "zh-TW",
      name: "繁体中文",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/zh-TW.ts"
      ]
    },
    {
      code: "ko",
      iso: "ko-KR",
      name: "한국어",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/ko.ts"
      ]
    },
    {
      code: "hi",
      iso: "hi-IN",
      name: "印地语",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/hi.ts"
      ]
    },
    {
      code: "de",
      iso: "de-DE",
      name: "德语",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/de.ts"
      ]
    },
    {
      code: "ar",
      iso: "ar-AE",
      name: "阿拉伯语",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/ar.ts"
      ]
    },
    {
      code: "fr",
      iso: "fr-FR",
      name: "法语",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/fr.ts"
      ]
    },
    {
      code: "id",
      iso: "id-ID",
      name: "印尼语",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/id.ts"
      ]
    },
    {
      code: "itb",
      iso: "it-IT",
      name: "意大利语",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/it.ts"
      ]
    },
    {
      code: "uk",
      iso: "uk-UA",
      name: "乌克兰语",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/uk.ts"
      ]
    }
  ],
  defaultLocale: "",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "no prefix",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    name: "English",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/en.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    iso: "zh-CN",
    name: "简体中文",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/zh-CN.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    iso: "ja-JP",
    name: "日文",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/ja.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "zh-TW",
    iso: "zh-TW",
    name: "繁体中文",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/zh-TW.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "ko",
    iso: "ko-KR",
    name: "한국어",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/ko.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "hi",
    iso: "hi-IN",
    name: "印地语",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/hi.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    iso: "de-DE",
    name: "德语",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/de.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "ar",
    iso: "ar-AE",
    name: "阿拉伯语",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/ar.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    iso: "fr-FR",
    name: "法语",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/fr.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "id",
    iso: "id-ID",
    name: "印尼语",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/id.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "itb",
    iso: "it-IT",
    name: "意大利语",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/it.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "uk",
    iso: "uk-UA",
    name: "乌克兰语",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz/i18n/locales/uk.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/